import React, { memo, useEffect, useLayoutEffect, useState } from 'react';
import NavigationPanel from './navigation-panel/NavigationPanel';
import AuthPanel from './auth-panel/AuthPanel';
import './Navbar.module.css';
import BurgerButton from './BurgerButton';
import { Link } from 'react-router-dom';
import MIcon from '../../common/m-icon/MIcon';
import useDeviceType from '@hooks/useDeviceType';
import { handleLanguageChange } from '@utils/translation.js';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useGetBackendVersionQuery } from '@api/oqulyqtarApi/VersionService.js';

const FRONTEND_VERSION = import.meta.env.VITE_VERSION || '';

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const role = useSelector(state=> state.user.activeRole);
    const isAuth = useSelector(state=> state.auth.isAuth);
    const [bgColor, setBgColor] = useState('bg-white');
    const {t, i18n} = useTranslation();

    const currentLang = i18n.language ? i18n.language.split('-')[0] : 'ru'

    useEffect(() => {
        const handleResize = (event) => {
            if (event.target.innerWidth > 1440) {
                setIsOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [isOpen]);

    useLayoutEffect(() => {
        switch (role) {
            // case 'school_admin':
            //     setBgColor('bg-school_admin');
            //     break;
            // case 'teacher':
            //     setBgColor('bg-teacher');
            //     break;
            // case 'student':
            //     setBgColor('bg-student');
            //     break;
            // case 'private_user':
            //     setBgColor('bg-private_user');
            //     break;
            // case 'superadmin':
            //     setBgColor('bg-superadmin');
            //     break;
            default:
                setBgColor('bg-white');
        }
    }, [role]);

    useEffect(() => {
        if (role==="superadmin" && currentLang === 'en') {
            handleLanguageChange('ru')
        }
    }, [i18n.language, role]);

    const toggleNavbar = async () => {
        setIsOpen(!isOpen);
    };

    const { isMobile } = useDeviceType();
    const { data: backendVersion } = useGetBackendVersionQuery();

    const version = backendVersion
        ? `${FRONTEND_VERSION}.${backendVersion.version}`
        : FRONTEND_VERSION;

    return (
      <nav
        className={`flex justify-between items-center px-[10px] flex-wrap w-full border-b border-b-[#00000033] ${isOpen ? 'fixed bg-white z-[70]' : bgColor}`}>
          {(!isOpen || !isMobile) && (
            <Link to='/'>
                <div className='h-[56px] flex items-center pl-[10px] desktop:pl-6 gap-2'>
                    <MIcon
                      type={'logo'}
                      className={`${isAuth ? 'text-black' : 'text-main-color'} cursor-pointer`}
                    />
                    {version && (
                        <span className='text-xs text-gray-400 self-end pb-2'>{version}</span>
                    )}
                </div>
            </Link>
          )}
          {isOpen
            ? (
              <>
                  <div className='hidden desktop:flex flex-row'>
                      <NavigationPanel role={role}/>
                  </div>

                  <div className='flex justify-end desktop:justify-end'>
                      <div className='flex mr-2 desktop:mr-0 '>
                          <AuthPanel isAuth={isAuth} role={role} isOpen={isOpen} setIsOpen={setIsOpen}/>
                      </div>
                      <BurgerButton toggleNavbar={toggleNavbar} isOpen={isOpen} setIsOpen={setIsOpen}/>
                  </div>
              </>
            )
            : (
              <>
                  <div className='hidden desktop:flex flex-row'>
                      <NavigationPanel isAuth={isAuth} role={role}/>
                  </div>

                  <div className='flex items-center justify-end desktop:justify-between'>
                      {/*<LangSwitcher*/}
                      {/*  classNameWrapper={isAuth ? "mr-4 text-black" : "mr-4 text-main-color"}*/}
                      {/*  classNameDropDown={isAuth ? `bg-white border` : "bg-white border border-main-color"}*/}
                      {/*  currentLang={currentLang.toUpperCase()}*/}
                      {/*  setCurrentLang={handleLanguageChange}*/}
                      {/*  options={options}*/}
                      {/*/>*/}
                      <div className='hidden tablet:flex mr-2 desktop:mr-0 items-center'>
                          <AuthPanel isAuth={isAuth} role={role} isOpen={isOpen} setIsOpen={setIsOpen}/>
                      </div>
                      <BurgerButton toggleNavbar={toggleNavbar} isOpen={isOpen} setIsOpen={setIsOpen}/>
                  </div>
              </>
            )
          }

          {isOpen && (
            <div className='flex flex-col basis-full h-screen border-t border-t-[#00000033]'>
                <NavigationPanel toggle={toggleNavbar} isOpen={isOpen} role={role} isAuth={isAuth}/>
            </div>
          )}
      </nav>
    );
}

export default memo(Navbar);
